import { Loadable } from '..';
import { AutoCompleteItem } from '../../components/ui/AutoCompleteItem';
import { HashMap } from '../../constants';
import { LoadTelsFilter } from '../AvailableTels';

/**
 * The number of seconds the application will wait before refreshing Available Tels from the server.
 */
export const AvailableTelsCacheTimeout = 300;

interface AvailableTels {
  available: AutoCompleteItem[];
  filter: LoadTelsFilter;
  all: AutoCompleteItem[];
  byTel: HashMap<boolean>;
}

export type AvailableTelsState = Loadable<AvailableTels>;

export const getDefaultAvailableTelsState = (): AvailableTelsState => {
  return {
    filter: {
      accountId: 0,
      networkId: 0,
    },
    all: [],
    available: [],
    byTel: {},
    isLoading: false,
  };
};
